import { render, staticRenderFns } from "./awards-winner.vue?vue&type=template&id=0f93b3f1&scoped=true&lang=pug&"
import script from "./awards-winner.vue?vue&type=script&lang=js&"
export * from "./awards-winner.vue?vue&type=script&lang=js&"
import style0 from "./awards-winner.vue?vue&type=style&index=0&id=0f93b3f1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f93b3f1",
  null
  
)

/* custom blocks */
import block0 from "./awards-winner.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {WidgetsListItem: require('/home/ubuntu/nuxt/bonkers/releases/20230331143208/components/widgets/list-item.vue').default})
